module.exports = __webpack_public_path__ + "img/achiote_menu1.15f9bd17.png";